/** Inline SVG icons lifted from the UI mockup. stroke=currentColor. */
const base = {
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
};

export function IconHome(props: { size?: number }) {
  return (
    <svg width={props.size ?? 22} height={props.size ?? 22} {...base}>
      <path d="M3 10v10h6v-6h6v6h6V10L12 3 3 10z" />
    </svg>
  );
}
export function IconClients(props: { size?: number }) {
  return (
    <svg width={props.size ?? 22} height={props.size ?? 22} {...base}>
      <circle cx="9" cy="8" r="3.2" />
      <path d="M3.5 20c0-3 2.6-5 5.5-5s5.5 2 5.5 5" />
      <path d="M16 5.3a3.2 3.2 0 0 1 0 5.4" />
      <path d="M17.5 14.7c2 .6 3.5 2.4 3.5 4.3" />
    </svg>
  );
}
export function IconSearch(props: { size?: number }) {
  return (
    <svg width={props.size ?? 22} height={props.size ?? 22} {...base}>
      <circle cx="11" cy="11" r="7" />
      <path d="m20 20-3.5-3.5" />
    </svg>
  );
}
export function IconCart(props: { size?: number }) {
  return (
    <svg width={props.size ?? 22} height={props.size ?? 22} {...base}>
      <path d="M3 4h2l2 12h12l2-8H7" />
      <circle cx="9" cy="20" r="1.5" />
      <circle cx="17" cy="20" r="1.5" />
    </svg>
  );
}
export function IconUser(props: { size?: number }) {
  return (
    <svg width={props.size ?? 22} height={props.size ?? 22} {...base}>
      <circle cx="12" cy="8" r="4" />
      <path d="M4 21c0-4 4-7 8-7s8 3 8 7" />
    </svg>
  );
}
export function IconScan(props: { size?: number }) {
  return (
    <svg width={props.size ?? 18} height={props.size ?? 18} {...base}>
      <path d="M4 7V5a1 1 0 0 1 1-1h2M17 4h2a1 1 0 0 1 1 1v2M20 17v2a1 1 0 0 1-1 1h-2M7 20H5a1 1 0 0 1-1-1v-2" />
      <path d="M3 12h18" />
    </svg>
  );
}
export function IconOrders(props: { size?: number }) {
  return (
    <svg width={props.size ?? 22} height={props.size ?? 22} {...base}>
      <path d="M8 4h8a2 2 0 0 1 2 2v14l-3-2-3 2-3-2-3 2V6a2 2 0 0 1 2-2z" />
      <path d="M9 9h6M9 13h6" />
    </svg>
  );
}
export function IconPin(props: { size?: number }) {
  return (
    <svg width={props.size ?? 16} height={props.size ?? 16} {...base}>
      <path d="M12 21s-6-5.4-6-10a6 6 0 0 1 12 0c0 4.6-6 10-6 10z" />
      <circle cx="12" cy="11" r="2.2" />
    </svg>
  );
}
export function IconPlus(props: { size?: number }) {
  return (
    <svg width={props.size ?? 18} height={props.size ?? 18} {...base} strokeWidth={2.2}>
      <path d="M12 5v14M5 12h14" />
    </svg>
  );
}
